import { useLocation, useNavigation } from "react-router-dom";

/**
 * Router ``useLocation()`` only updates after loaders resolve, so chrome
 * (sidebar, breadcrumbs) lag behind clicks if we read it alone. During
 * ``loading`` / ``submitting``, ``useNavigation().location`` reflects the
 * destination — use it for immediate visual feedback.
 */
export function useHighlightedPathname(): string {
  const { pathname } = useLocation();
  const navigation = useNavigation();
  if (
    navigation.state !== "idle" &&
    navigation.location?.pathname !== undefined &&
    navigation.location.pathname !== ""
  ) {
    return navigation.location.pathname;
  }
  return pathname || "/";
}
